import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import * as React from 'react';
import Common from '../utilities/common';
import $ from "jquery";
import { TrameroSearchModel } from '../Tramero/TrameroSearchModel';
import { Apellido } from '../Apellidos/Apellido';

export interface IRepairSexoProps {
    open: boolean;
    id: number;
    onCancel?: any;
    onSave?: any;
}

export interface IRepairSexoState {
    tramero: any[];
    searchingTramero: boolean;
    normalizacionItem: any;
    open: boolean;
    hasErrors: boolean;
}

export default class RepairSexo extends React.Component<IRepairSexoProps, IRepairSexoState> {
    _sexo: string = '';
    _id: number = -1;

    public constructor(props: IRepairSexoProps) {
        super(props);

        this.state = {
            tramero: [],
            searchingTramero: true,
            open: false,
            normalizacionItem: null,
            hasErrors: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IRepairSexoProps>, nextContext: any): void {
        this._id = nextProps.id;
        this.setState({
            open: nextProps.open
        });

        this.GetData();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    {
                        `Reparar código postal`
                    }
                </DialogTitle>
                <DialogContent>
                    <FormControl fullWidth variant="standard">
                        <InputLabel id="labelComunidadAutonoma">Seleccione el sexo</InputLabel>
                        <Select label="Seleccione el sexo" defaultValue='' labelId='labelComunidadAutonoma' onChange={(event: SelectChangeEvent) => {
                            this._sexo = event.target.value;
                        }}>
                            <MenuItem value={'M'}>Femenino</MenuItem>
                            <MenuItem value={'H'}>Masculino</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Save.bind(this)}>Ok</Button>
                    {
                        !this.state.hasErrors && (
                            <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                        )
                    }
                </DialogActions>
            </Dialog>
        )
    }

    private GetData() {
        let url = `${Common.END_POINT}/normalizaciones/data/${this._id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    normalizacionItem: response[0]
                }
            );
        });
    }

    private Save() {
        if(this.state.hasErrors) {
            this.Close();
            return;
        }
        const normalizacionItem = JSON.parse(JSON.stringify(this.state.normalizacionItem));
        normalizacionItem.sexo = this._sexo;

        if(normalizacionItem.fechaNacimiento.indexOf == undefined) {
            normalizacionItem.fechaNacimiento = '';
        }

        let url = `${Common.END_POINT}/normalizaciones/data/${this._id}/update`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(normalizacionItem),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: boolean) => {
            if(this.props.onSave != null) {
                this.props.onSave(response);
            }
        })
    }

    private Close() {
        if(this.props.onCancel != null) {
            this.props.onCancel();
        }
    }
}